import React from 'react';
import { Trans } from 'react-i18next';

export const renderKeywordSettingSearchResult = (name, result) => {
  return (
    <Trans
      i18nKey='limitation.labels.settingSearchResult'
      values={{ name, result }}
      components={{ 2: <span className='count' /> }}
    />
  );
};
